import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { Observable } from 'rxjs';
import { DoctorSpecialization } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class DoctorSpecializationService extends ApiService {
    endpoint = '/api/doctor-specialization';

    getDoctorSpecializations(doctorId: string): Observable<DoctorSpecialization[]> {
        return this.http.get<DoctorSpecialization[]>(`${this.doctorBaseURL}${this.endpoint}/doctor/${doctorId}`);
    }

    get(id: string): Observable<DoctorSpecialization> {
        return this.http.get<DoctorSpecialization>(`${this.doctorBaseURL}${this.endpoint}/${id}`);
    }

    create(model: DoctorSpecialization): Observable<DoctorSpecialization> {
        return this.http.post<DoctorSpecialization>(`${this.doctorBaseURL}${this.endpoint}`, model);
    }

    update(model: DoctorSpecialization): Observable<DoctorSpecialization> {
        return this.http.put<DoctorSpecialization>(`${this.doctorBaseURL}${this.endpoint}`, model);
    }

    delete(id: string): Observable<DoctorSpecialization> {
        return this.http.delete<DoctorSpecialization>(`${this.doctorBaseURL}${this.endpoint}/${id}`);
    }
}